<div class="row mx-0">
  <div class="col-md-2 d-flex align-items-center">
    <p class="bold">Status:</p>
  </div>

  @if (!updating) {
    <div>
      <!-- Active -->
      @if (mapEntity?.isActive) {
        <div class="col-md-10">
          <span class="badge bg-info text-white px-3 py-2 fs-6">Active</span>
          @if (showButtons) {
            <div class="float-end">
              <button type="button" class="btn btn-danger ms-2" (click)="deactivateSafezone()">
                Deactivate <i class="fa fa-toggle-off"></i>
              </button>
            </div>
          }
        </div>
      }
      <!-- Inactive -->
      @if (!mapEntity?.isActive) {
        <div class="col-md-10">
          <span class="badge bg-primary text-white px-3 py-2 fs-6">Inactive</span>
          @if (showButtons) {
            <div class="float-end">
              <button type="button" class="btn btn-danger ms-2" (click)="activateSafezone()">
                Activate <i class="fa fa-toggle-on"></i>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (updating) {
    <div class="col-md-10">
      <!-- Replace with your Angular loader -->
      <!-- <app-wave-spinner></app-wave-spinner> -->
    </div>
  }
</div>

<hr />

<div class="ps-3">
  <p class="bold">Description:</p>
  <!-- <p>{{ mapEntity?.getDescription() }}</p> -->
</div>


<!-- Optional Delete Button -->
<!--
<div class="pe-3 pb-3 float-end" *ngIf="showButtons">
  <button type="button" class="btn btn-danger" (click)="deleteSafezone()">
    <i class="fa fa-trash"></i>
  </button>
</div>
-->

@if (updating) {
  <div class="loader-overlay">
    <div class="spinner-border text-primary me-2" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <span class="fw-bold">Processing...</span>
  </div>
}